<mat-toolbar class="dashboard-footer">
  <span>AllUnited AI Planner &copy; | 2025</span>
</mat-toolbar>
